export const formStructure = [[
  {
    name: 'Categoria',
    label: 'Categoria',
    placeholder: 'Digite o nome da Categoria',
    component: 'FormField',
    type: 'text',
    colProps: { md: 6 },
    required: true,
    maxLength: 50,
    validation: { required: 'Categoria é obrigatório' }
  },
  {
    name: 'Nome',
    label: 'Nome',
    placeholder: 'Digite o título do Benefício',
    component: 'FormField',
    type: 'text',
    colProps: { md: 6 },
    required: true,
    maxLength: 100,
    validation: { required: 'Nome é obrigatório' }
  }
]];

export const formSections = initialValues => [{
  title: `Detalhes do Beneficio ${initialValues.Categoria || ''}`,
  rows: [0, 1]

}];

export const validateForm = values => {
  const errors = {};

  if (!values?.Categoria || String(values.Categoria).trim().length === 0) {
    errors.Categoria = 'Categoria é obrigatória';
  }

  if (!values?.Nome || String(values.Nome).trim().length === 0) {
    errors.Nome = 'Nome é obrigatório';
  }

  return errors;
};